import React, { useEffect } from "react";
import Lenis from "lenis";
import { useContent } from "@/context/ContentContext";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Categories from "@/components/site/Categories";
import MarqueeStrip from "@/components/site/Marquee";
import Team from "@/components/site/Team";
import Manifesto from "@/components/site/Manifesto";
import Faq from "@/components/site/Faq";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import { Loader2 } from "lucide-react";

export default function PublicSite() {
  const { content, loading } = useContent();

  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    // Smooth-scroll for in-page anchor links
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id && id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80 });
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, [content]);

  if (loading || !content) {
    return (
      <div className="min-h-screen grid place-items-center bg-stone-950">
        <Loader2 className="h-8 w-8 animate-spin text-amber-500" />
      </div>
    );
  }

  return (
    <div className="bg-stone-950 text-stone-50 min-h-screen">
      <Header content={content} />
      <main>
        <Hero hero={content.hero} />
        <Categories categories={content.categories} />
        <MarqueeStrip marquee={content.marquee} />
        <Team team={content.team} />
        <Manifesto manifesto={content.manifesto} />
        <Faq faq={content.faq} />
        <Contact contact={content.contact} />
      </main>
      <Footer content={content} />
    </div>
  );
}
